export default __webpack_public_path__ + "static/media/icon-artefact-image.30f075c8.svg";